import { Component, forwardRef } from '@angular/core';
import { CacheDataService } from '../../api/services/cache-data.service';
import { FlatTreeControl } from '@angular/cdk/tree';
import { TreeViewSelectionNode } from './helpers/tree-view-selection-node';
import { TreeViewDataSource } from './helpers/tree-vew-data-source';
import { FilterEditorComponent } from './filter-editor/filter-editor.component';
import { Industry } from '../../api/models/industry';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IndustryKey } from '../../api/models/industry-key';

@Component({
  selector: 'industry-filter-editor',
  templateUrl: './filter-editor/filter-editor.component.html',
  styleUrls: ['./filter-editor/filter-editor.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IndustryFilterEditorComponent),
      multi: true,
    },
  ],
})
export class IndustryFilterEditorComponent extends FilterEditorComponent<Industry, IndustryKey, TVSNIndustry, IndustryDataSource> implements ControlValueAccessor {

  constructor(cacheDataService: CacheDataService) {
    super(cacheDataService);
  }

  protected getNewDataSource(treeControl: FlatTreeControl<TVSNIndustry, TVSNIndustry>, cacheDataService: CacheDataService): IndustryDataSource {
    return new IndustryDataSource(treeControl, cacheDataService);
  }
}

export class IndustryDataSource extends TreeViewDataSource<Industry, IndustryKey, TVSNIndustry> {

  constructor(
    treeControl: FlatTreeControl<TVSNIndustry>,
    public cacheDataService: CacheDataService) {
    super(treeControl);
  }

  protected loadInitialData(callback: (results: TVSNIndustry[]) => void) {
    this.cacheDataService.cacheDataGetIndustrySectors({ pageNumber: 1, pageSize: 1000 }).subscribe((result) => {
        const nodes = result.page.map((item) => new TVSNIndustry(
          [], this.blankCover(item.sector), 1,
          {
            sector: item.sector
          },
          undefined,
          true,
          true
        ));
        callback(nodes);
      });
  }

  protected loadChildNodes(node: TVSNIndustry, callback: (results: TVSNIndustry[]) => void) {
    if (node.level === 1) {
      // Load industries under a specific sector
      this.cacheDataService.cacheDataGetIndustryIndustriesBySector({sector: node.sourceValue.sector, pageNumber: 1, pageSize: 1000}).subscribe((result) => {
        const nodes: TVSNIndustry[] = result.page.map((item) => new TVSNIndustry(
          [], this.blankCover(item.mainIndustry), node.level + 1,
          {
            ...item
          },
          node,
          false,
          true
        ));
        callback(nodes);
      });
    } /*else if (node.level === 2) {
      // Load the final industries for the selected industry group
      this.cacheDataService
        .cacheDataGetIndustriesBySectorAndIndustry({
          sector: node.sourceValue.sector,
          industry: node.sourceValue.mainIndustry,
          pageNumber: 1,
          pageSize: 1000,
        })
        .subscribe((result) => {
          const nodes: TVSNIndustry[] = result.page.map(
            (item) =>
              new TVSNIndustry(
                [], item.label, node.level + 1,
                {
                  ...item
                },
                node,
                false,
                true
              )
          );
          callback(nodes);
        });
    }*/
  }
}

export class TVSNIndustry extends TreeViewSelectionNode<
  Industry,
  IndustryKey
> {
  protected deriveKey(): IndustryKey {
    return {
      sector: this.sourceValue.sector,
      industry: this.sourceValue.mainIndustry,
      id: this.sourceValue.id
    };
  }

  protected isAnyKnownChildSelected(allKnownSelections: IndustryKey[]): boolean {
    if (this.sourceValue.mainIndustry === undefined) {
      return allKnownSelections?.some(x => x.sector == this.sourceValue.sector);
    }
    return false;
  }

  public isKeyForMe(key: IndustryKey): boolean {
    return key.id === this.sourceValue.id
      && key.industry === this.sourceValue.mainIndustry
      && key.sector === this.sourceValue.sector;
  }

  public isChildOf(key: IndustryKey): boolean {
    if (key.industry != null) {
      return key.industry === this.sourceValue.mainIndustry
        && key.sector === this.sourceValue.sector;
    } else if (key.sector != null) {
      return key.sector === this.sourceValue.sector;
    }

    return false;
  }

  public toSourceKey(): IndustryKey {
    return {
      sector: this.sourceValue.sector,
      industry: this.sourceValue.mainIndustry,
      id: this.sourceValue.id
    }
  }

  public matchesKey(key: IndustryKey): boolean {
    return key.id === this.sourceValue.id
      && key.industry === this.sourceValue.mainIndustry
      && key.sector === this.sourceValue.sector;
  }
}
